// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1InvoiceSchema } from './v1/invoiceSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const patchExportInvoiceToIntegrationPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
  id: z.number().int().describe("Invoice id"),
});

export const patchExportInvoiceToIntegrationHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Invoice exported successfully
 */
export const patchExportInvoiceToIntegration200Schema = z.lazy(() => v1InvoiceSchema);

/**
 * @description Forbidden - Insufficient permissions
 */
export const patchExportInvoiceToIntegration403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Invoice not found
 */
export const patchExportInvoiceToIntegration404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const patchExportInvoiceToIntegrationMutationResponseSchema = z.lazy(() => patchExportInvoiceToIntegration200Schema);
